/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FullProductDto } from '../models/full-product-dto';
import { MinimalProductDto } from '../models/minimal-product-dto';
import { productAddNew$Json } from '../fn/product/product-add-new-json';
import { ProductAddNew$Json$Params } from '../fn/product/product-add-new-json';
import { productAddNew$Plain } from '../fn/product/product-add-new-plain';
import { ProductAddNew$Plain$Params } from '../fn/product/product-add-new-plain';
import { productDeleteProduct } from '../fn/product/product-delete-product';
import { ProductDeleteProduct$Params } from '../fn/product/product-delete-product';
import { productGetAllEditorMenus$Json } from '../fn/product/product-get-all-editor-menus-json';
import { ProductGetAllEditorMenus$Json$Params } from '../fn/product/product-get-all-editor-menus-json';
import { productGetAllEditorMenus$Plain } from '../fn/product/product-get-all-editor-menus-plain';
import { ProductGetAllEditorMenus$Plain$Params } from '../fn/product/product-get-all-editor-menus-plain';
import { productGetProductById$Json } from '../fn/product/product-get-product-by-id-json';
import { ProductGetProductById$Json$Params } from '../fn/product/product-get-product-by-id-json';
import { productGetProductById$Plain } from '../fn/product/product-get-product-by-id-plain';
import { ProductGetProductById$Plain$Params } from '../fn/product/product-get-product-by-id-plain';
import { productGetType$Json } from '../fn/product/product-get-type-json';
import { ProductGetType$Json$Params } from '../fn/product/product-get-type-json';
import { productGetType$Plain } from '../fn/product/product-get-type-plain';
import { ProductGetType$Plain$Params } from '../fn/product/product-get-type-plain';
import { productReorder } from '../fn/product/product-reorder';
import { ProductReorder$Params } from '../fn/product/product-reorder';
import { productSetProductImageById } from '../fn/product/product-set-product-image-by-id';
import { ProductSetProductImageById$Params } from '../fn/product/product-set-product-image-by-id';
import { productSetProductNameById } from '../fn/product/product-set-product-name-by-id';
import { ProductSetProductNameById$Params } from '../fn/product/product-set-product-name-by-id';
import { ProductTypeEnum } from '../models/product-type-enum';

@Injectable({ providedIn: 'root' })
export class ProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productGetAllEditorMenus()` */
  static readonly ProductGetAllEditorMenusPath = '/api/Product/minimal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetAllEditorMenus$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetAllEditorMenus$Plain$Response(params?: ProductGetAllEditorMenus$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MinimalProductDto>>> {
    return productGetAllEditorMenus$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productGetAllEditorMenus$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetAllEditorMenus$Plain(params?: ProductGetAllEditorMenus$Plain$Params, context?: HttpContext): Observable<Array<MinimalProductDto>> {
    return this.productGetAllEditorMenus$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MinimalProductDto>>): Array<MinimalProductDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetAllEditorMenus$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetAllEditorMenus$Json$Response(params?: ProductGetAllEditorMenus$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MinimalProductDto>>> {
    return productGetAllEditorMenus$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productGetAllEditorMenus$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetAllEditorMenus$Json(params?: ProductGetAllEditorMenus$Json$Params, context?: HttpContext): Observable<Array<MinimalProductDto>> {
    return this.productGetAllEditorMenus$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MinimalProductDto>>): Array<MinimalProductDto> => r.body)
    );
  }

  /** Path part for operation `productGetProductById()` */
  static readonly ProductGetProductByIdPath = '/api/Product/full/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetProductById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetProductById$Plain$Response(params: ProductGetProductById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<FullProductDto>> {
    return productGetProductById$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productGetProductById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetProductById$Plain(params: ProductGetProductById$Plain$Params, context?: HttpContext): Observable<FullProductDto> {
    return this.productGetProductById$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<FullProductDto>): FullProductDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetProductById$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetProductById$Json$Response(params: ProductGetProductById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<FullProductDto>> {
    return productGetProductById$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productGetProductById$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetProductById$Json(params: ProductGetProductById$Json$Params, context?: HttpContext): Observable<FullProductDto> {
    return this.productGetProductById$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<FullProductDto>): FullProductDto => r.body)
    );
  }

  /** Path part for operation `productSetProductNameById()` */
  static readonly ProductSetProductNameByIdPath = '/api/Product/{productId}/set/name';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productSetProductNameById()` instead.
   *
   * This method doesn't expect any request body.
   */
  productSetProductNameById$Response(params: ProductSetProductNameById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productSetProductNameById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productSetProductNameById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productSetProductNameById(params: ProductSetProductNameById$Params, context?: HttpContext): Observable<void> {
    return this.productSetProductNameById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productSetProductImageById()` */
  static readonly ProductSetProductImageByIdPath = '/api/Product/{productId}/set/image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productSetProductImageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  productSetProductImageById$Response(params: ProductSetProductImageById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productSetProductImageById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productSetProductImageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productSetProductImageById(params: ProductSetProductImageById$Params, context?: HttpContext): Observable<void> {
    return this.productSetProductImageById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productReorder()` */
  static readonly ProductReorderPath = '/api/Product/{productId}/reorder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productReorder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  productReorder$Response(params: ProductReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productReorder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productReorder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  productReorder(params: ProductReorder$Params, context?: HttpContext): Observable<void> {
    return this.productReorder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productAddNew()` */
  static readonly ProductAddNewPath = '/api/Product/new';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAddNew$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAddNew$Plain$Response(params?: ProductAddNew$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MinimalProductDto>> {
    return productAddNew$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAddNew$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAddNew$Plain(params?: ProductAddNew$Plain$Params, context?: HttpContext): Observable<MinimalProductDto> {
    return this.productAddNew$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<MinimalProductDto>): MinimalProductDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productAddNew$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAddNew$Json$Response(params?: ProductAddNew$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MinimalProductDto>> {
    return productAddNew$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productAddNew$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productAddNew$Json(params?: ProductAddNew$Json$Params, context?: HttpContext): Observable<MinimalProductDto> {
    return this.productAddNew$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<MinimalProductDto>): MinimalProductDto => r.body)
    );
  }

  /** Path part for operation `productGetType()` */
  static readonly ProductGetTypePath = '/api/Product/type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetType$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetType$Plain$Response(params?: ProductGetType$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductTypeEnum>> {
    return productGetType$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productGetType$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetType$Plain(params?: ProductGetType$Plain$Params, context?: HttpContext): Observable<ProductTypeEnum> {
    return this.productGetType$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductTypeEnum>): ProductTypeEnum => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productGetType$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetType$Json$Response(params?: ProductGetType$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductTypeEnum>> {
    return productGetType$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productGetType$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productGetType$Json(params?: ProductGetType$Json$Params, context?: HttpContext): Observable<ProductTypeEnum> {
    return this.productGetType$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductTypeEnum>): ProductTypeEnum => r.body)
    );
  }

  /** Path part for operation `productDeleteProduct()` */
  static readonly ProductDeleteProductPath = '/api/Product/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productDeleteProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDeleteProduct$Response(params: ProductDeleteProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productDeleteProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productDeleteProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productDeleteProduct(params: ProductDeleteProduct$Params, context?: HttpContext): Observable<void> {
    return this.productDeleteProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
